import { IAbstractPredicateNode } from '../predicate.types';
import { ExpressionPredicateNodeTree } from './predicate-tree.types';

export function convertPredicateNodeListToLogicalExpressionTree<
  T extends IAbstractPredicateNode<number>
>(nodes: T[]): ExpressionPredicateNodeTree<T> {
  const root: ExpressionPredicateNodeTree<T> = [];
  const stack: ExpressionPredicateNodeTree<T>[] = [root];

  for (const node of nodes) {
    if (node.isStartBracket()) {
      // Create new nested expression level
      const newGroup: ExpressionPredicateNodeTree<T> = [node];
      stack[stack.length - 1].push(newGroup);
      stack.push(newGroup);
    } else if (node.isCloseBracket()) {
      // Close the current group
      stack[stack.length - 1].push(node);
      stack.pop();
    } else {
      // Normal node (operand, operator, etc.)
      stack[stack.length - 1].push(node);
    }
  }

  return root;
}

/**
 *  Pre-order tree traversal visits each node using stack.
 *  Checks if leaf node is not an array otherwise
 *  pushes all nodes into stack and continues traversal.
 *  @param {ExpressionPredicateNodeTree} root - expression tree to add
 *  @returns array  - final array of nodes in order
 */
export function convertLogicalExpressionTreeToPredicateNodeList<
  T extends IAbstractPredicateNode<number>
>(root: ExpressionPredicateNodeTree<T>) {
  const nodeList: T[] = [];

  for (const node of root) {
    if (!Array.isArray(node)) {
      nodeList.push(node);
    } else {
      nodeList.push(...convertLogicalExpressionTreeToPredicateNodeList(node));
    }
  }

  nodeList.forEach((node, index) => {
    node.order = index + 1;
  });

  return nodeList;
}
